import { IContentExpander } from '@models/IContentExpander';
//import SiteEnum from '@models/enums/SiteEnum';
import SharedContentExpander from '@organisms/ContentExpander/ContentExpander';

const ContentExpander = (props: IContentExpander) => (
  <SharedContentExpander {...props} /> // TODO: add to component site={SiteEnum.Deco} to component?
);

export default ContentExpander;
